<template>
	<div class="logo-card">
		<div class="overlay-backdrop" v-for="i in viewModal" :key="i"></div>
		<div class="logo-card__image-view">
			<!-- DEV NOTE: logo-card__image-zoom will not display when a logo has not been uploaded. -->
			<div class="logo-card__image-zoom">
				<Button
					className="btn--icon-only"
					iconClassName="icon-zoom"
					:btnClick="() => {}"
					:iconBeforeLabel="true"
				/>
			</div>
			<figure class="logo-card__image">
				<img :src="logoImgSrc" :alt="logoImgAlt" />
			</figure>
		</div>
		<div class="logo-card__title">
			{{ logoTitle }}
		</div>
		<!-- DEV NOTE: logo-card__actions will not display for non-privileged users -->
		<div class="logo-card__actions">
			<Button
				aria-label="Upload"
				className="btn--icon-only"
				iconClassName="icon-upload"
				:btnClick="
					() => {
						viewModal++;
					}
				"
				:iconBeforeLabel="true"
			/>
			<!-- DEV NOTE: Modal title is Upload Logo.  Need an "Upload Logo" btn-primary and "Cancel" btn-link -->
			<Modals v-for="i in viewModal" :key="i" />
			<Button
				aria-label="Delete"
				className="btn--icon-only"
				iconClassName="icon-delete-glenn"
				:btnClick="() => {}"
				:iconBeforeLabel="true"
			/>
		</div>
	</div>

	<!---------- DEV NOTES -----------------
    -- Modal component is pending development's implementation
    -- Modal placement and "overlay-backdrop" div are for ui/ux visual testing purposes. 
	-- MODALS: Upload, Delete, Preview
    -- Content file is in "Content" folder. NOTE: Only content for Upload Load Modal has been created.
    -- Upload Modal is Fullscreen.
    -- Preview modal is Centered.
    -- Delete is Confirmation.
	-->
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Button from '@/components/forms/button/button';

export default {
	name: 'LogoCard',
	props: {
		logoTitle: String,
		logoImgSrc: {
			type: String,
			default: '/img/no-image.97b2a2c7.svg' //temp for UI/UX visual only
		},
		logoImgAlt: {
			type: String,
			default: 'No logo uploaded'
		}
	},
	components: {
		Modals,
		Button
	},
	data() {
		return {
			viewModal: 0
		};
	}
};
</script>

<style lang="scss">
/**
    * [Description]
    *
    * Logo Card
    * Can use SCSS variables = TRUE
    *
    * [Table of Contents]
    *
    * CARD CONTENT LAYOUT
 */

/*------------------------------------*\
  #CARD CONTENT LAYOUT
\*------------------------------------*/
@import '@/scss/5-objects/_cards.scss';

.logo-card {
	@include card;

	&__image-view {
		display: flex;
		flex-direction: column;
		height: 105px;

		@include mq($from: md) {
			height: 120px;
		}
	}

	&__image-zoom {
		font-size: $icon-font-size;
		display: flex;
		justify-content: flex-end;
		color: $neutral-3;
	}

	&__image {
		padding: $padding-sm $padding-md;
		text-align: center;
		height: 80%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
	}

	&__title {
		font-weight: $medium-font-weight;
		text-align: center;
		margin: $gutter-md 0;
		font-size: $default-font-size;
	}

	&__actions {
		display: flex;
		justify-content: space-between;
		border-top: 1px solid $card-border-color;
		margin-top: $gutter-md;
		padding-top: $padding-sm;
		font-size: $icon-font-size;
	}
}
</style>
